//function to get the other concept e.g. question, strategy
export function otherConcept (concept) {
	if(concept == 'question') {
		return 'strategy';
	} else {
		return 'question';
	} 
}
